var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Dependencies } from "~/core/decorator";
import { Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { CaseApplyManageService } from "~/services/business-service/case-apply-manage.service";
import ApproveDetails from "~/components/collection-manage/collection-application/approve-details.vue";
var collectionManageModule = namespace("collection-manage");
var CoUrgingQuery = /** @class */ (function (_super) {
    __extends(CoUrgingQuery, _super);
    function CoUrgingQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowData = {};
        _this.loading = { state: false };
        _this.dataSet = [];
        _this.queryParamsModel = {
            caseId: "",
            flowType: "VISIT_APPLY",
        };
        _this.dialog = {
            approveDetail: false,
        };
        return _this;
    }
    CoUrgingQuery.prototype.onCaseIdChanged = function (val) {
        val && this.refreshData();
    };
    CoUrgingQuery.prototype.onAssistCountChange = function (val) {
        val && this.refreshData();
    };
    CoUrgingQuery.prototype.approveDetail = function (row) {
        this.dialog.approveDetail = true;
        this.rowData = row;
    };
    CoUrgingQuery.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.queryParamsModel.caseId = this.caseId;
        this.caseApplyManageService.getProcessApplicationByFlowType(this.queryParamsModel, this.pageService, this.sortService, this.loading).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], CoUrgingQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CoUrgingQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], CoUrgingQuery.prototype, "caseApplyManageService", void 0);
    __decorate([
        collectionManageModule.State
    ], CoUrgingQuery.prototype, "assistCount", void 0);
    __decorate([
        Prop({ required: true, default: "" })
    ], CoUrgingQuery.prototype, "caseId", void 0);
    __decorate([
        Watch("caseId", { immediate: true })
    ], CoUrgingQuery.prototype, "onCaseIdChanged", null);
    __decorate([
        Watch("assistCount")
    ], CoUrgingQuery.prototype, "onAssistCountChange", null);
    CoUrgingQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ApproveDetails: ApproveDetails,
            },
        })
    ], CoUrgingQuery);
    return CoUrgingQuery;
}(Vue));
export default CoUrgingQuery;
